import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import Button from 'components/Form/Button';
import { useAction } from 'hooks';
import * as actions from '../../../../actions';
import * as constants from '../../../../constants';
import * as selectors from '../../../../selectors';
import messages from '../../../../messages';
import styles from './Actions.pcss';
const LoadMore = ()=>{
    const notificationsFilter = useSelector(selectors.notificationsFilter);
    const hasMoreNotificationsToLoad = useSelector(selectors.hasMoreNotificationsToLoad);
    const isInProgress = useSelector(selectors.isFetchNotificationsInProgress);
    const isDismissInProgress = useSelector(selectors.isDismissFilteredNotificationsInProgress);
    const setNotificationsFilter = useAction(actions.setNotificationFilterParams);
    return /*#__PURE__*/ _jsx(Button, {
        type: "button",
        styleModifier: "primary",
        labelMessage: messages.buttons.loadMore,
        className: "btn--sm btn--transparent",
        isDisabled: !hasMoreNotificationsToLoad || isDismissInProgress || isInProgress,
        isInProgress: isInProgress,
        onClick: ()=>{
            setNotificationsFilter({
                limit: notificationsFilter.limit + constants.NOTIFICATIONS_LIST_LENGTH
            });
        }
    });
};
const DismissAll = ()=>{
    const hasAnyNotificationsToDismiss = useSelector(selectors.hasAnyNotificationsToDismiss);
    const isInProgress = useSelector(selectors.isDismissFilteredNotificationsInProgress);
    const dismissAll = useAction(actions.dismissFilteredNotification);
    return /*#__PURE__*/ _jsx(Button, {
        type: "button",
        styleModifier: "secondary",
        labelMessage: messages.buttons.dismissAll,
        isDisabled: !hasAnyNotificationsToDismiss,
        isInProgress: isInProgress,
        className: "btn--sm btn--transparent",
        onClick: dismissAll
    });
};
const Actions = ()=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.actions,
        "data-testid": "notifications-list-actions",
        children: [
            /*#__PURE__*/ _jsx(LoadMore, {}),
            /*#__PURE__*/ _jsx(DismissAll, {})
        ]
    });
};
export default Actions;
